import DashboardMedia from "../../Components/DashboardMedia";


export const DashboardMediaComponent = () => {
    return (
      <>
        <DashboardMedia/>
      </>
    );
  };